export var DEFAULT_LOCALE = 'en';
export var DEFAULT_TIME_ZONE = 'Europe/London';
export var TIME_ZONE_KEY = 'timeZone';